
import { dialog } from "./categories/dialog";
import { embedding } from "./categories/embedding";
import { featureManagement } from "./categories/pt-BR/feature-management";
import { navigation } from "./categories/pt-BR/navigation";
import { playback } from "./categories/pt-BR/playback";
import { speedTesting } from "./categories/pt-BR/speed-testing";
import { tracking } from "./categories/pt-BR/tracking";
import { uiActions } from "./categories/pt-BR/ui-actions";
import { userProfile } from "./categories/pt-BR/user-profile";
import { videoContent } from "./categories/pt-BR/video-content";
import { VisualElements } from "./categories/pt-BR/visual-elements";
import { autoplayOverlay } from "./categories/pt-BR/autoplay-overlay";
import { salesNotification as salesNotificationTranslations } from "./categories/pt-BR/salesNotification";
import { videoControls } from "./categories/pt-BR/video-controls";
import { audience as audienceTranslations } from "./categories/pt-BR/audience";
import { support } from "./categories/pt-BR/support";
import { logo } from "./categories/pt-BR/logo";
import { Border } from "./categories/pt-BR/border";
import { pages } from "./categories/pt-BR/pages";

// Utility function to add namespace prefix to translation keys
const prefix = (ns: string, obj: Record<string, string>): Record<string, string> => {
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [`${ns}.${k}`, v])
  );
};

// Translations for Brazilian Portuguese
export const ptBR = {
  ...dialog,
  ...embedding,
  ...featureManagement,
  ...navigation,
  ...playback,
  ...speedTesting,
  ...tracking,
  ...uiActions,
  ...userProfile,
  ...videoContent,
  ...VisualElements,
  ...autoplayOverlay,
  ...videoControls,
  ...support,
  ...logo,
  ...Border,
  // Apply namespace prefixes for components that use namespaced keys
  ...prefix('salesNotification', salesNotificationTranslations),
  ...prefix('audience', audienceTranslations),
  ...pages,
};
